import { ApiService } from "./apiService"

export const MemoriesService = ()=>{
    return {
        getAll:async()=>{
            const  response = await ApiService.get(`/api/items/memories?fields=date,title,id,description,files.directus_files_id.*&filter[status][_eq]=published`);
            return response.data
        },
        getFiles:async (id:number)=>{
            const response = await ApiService.get(`/api/items/memories?fields=files.directus_files_id.*&filter[id][_eq]=${id} `);
            return response.data;
        }
    }
}